import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const CheckoutBillingAddressContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "orgDashboard/CheckoutBillingAddressContainer" */
      './CheckoutBillingAddressContainer'
    ),
});
